// extracted by mini-css-extract-plugin
export default {"ShowMoreLink":"zf8XLYwz","NotesModalText":"pXVxG0av"};